import template from './publishStatusIcon.html';

const PublishStatusIconController = function controller($q, $log, schemaService) {
  const $ctrl = this;

  $ctrl.$onChanges = (changes) => {
    if (changes.status.currentValue) {
      schemaService.getStatuses('publish').then((data) => {
        $ctrl.class = data.find(val => +val.id === +$ctrl.status).icon;
      });
    }
  };
};

const controllerArr = [
  '$q',
  '$log',
  'schemaService',
  PublishStatusIconController
];

const component = {
  template,
  bindings: {
    status: '<'
  },
  controller: 'PublishStatusIconController'
};

export default function (ngModule) {
  ngModule.component('publishStatusIcon', component);
  ngModule.controller('PublishStatusIconController', controllerArr);
}
